export type ReadOnlyProviderProps = {
  section: string;
  children: React.ReactNode;
};

export type ReadOnlyContextType = {
  onReadOnly: () => void;
  readOnly: boolean;
};

export const defaultValues = {
  onReadOnly: (): undefined => undefined,
  readOnly: false,
};
